/* istanbul ignore next */
export function redirect(url) {
	window.location = url;
}

/* istanbul ignore next */
export function location() {
	if (typeof window !== 'undefined') {
		return window.location;
	} else {
		return undefined;
	}
}

/* istanbul ignore next */
export function origin() {
	if (typeof window === 'undefined' || !window.location) {
		return undefined;
	}

	let origin = window.location.origin;
	if (!origin) {
		origin = `${window.location.protocol}//${window.location.hostname}${
			window.location.port ? `:${window.location.port}` : ''
		}`;
	}
	return origin;
}

/* istanbul ignore next */
export function reload() {
	if (typeof window !== 'undefined') {
		window.location.reload();
	}
}

/* istanbul ignore next */
export function confirm(message) {
	if (typeof window === 'undefined') {
		return true;
	}

	return window.confirm(message);
}

/* istanbul ignore next */
export function addEventListener(...args) {
	if (typeof window !== 'undefined') {
		window.addEventListener.apply(window, args);
	}
}

/* istanbul ignore next */
export function removeEventListener(...args) {
	if (typeof window !== 'undefined') {
		window.removeEventListener.apply(window, args);
	}
}

/* istanbul ignore next */
export function getOuterHeight(element) {
	if (typeof window === 'undefined') {
		return element.offsetHeight;
	}

	const style = window.getComputedStyle(element);
	const height = element.offsetHeight;

	return height + parseInt(style.marginTop) + parseInt(style.marginBottom);
}
/* istanbul ignore next */
export function getInnerHeight(element) {
	if (typeof window === 'undefined') {
		return element.offsetHeight;
	}

	const style = window.getComputedStyle(element);
	const height = element.offsetHeight;

	return (
		height -
		parseInt(style.paddingTop) -
		parseInt(style.paddingBottom) -
		parseInt(style.borderTopWidth) -
		parseInt(style.borderBottomWidth)
	);
}

/* istanbul ignore next */
export function getOuterWidth(element) {
	if (typeof window === 'undefined') {
		return element.offsetWidth;
	}

	const style = window.getComputedStyle(element);
	const width = element.offsetWidth;

	return width + parseInt(style.marginLeft) + parseInt(style.marginRight);
}

/* istanbul ignore next */
export function pageYOffset() {
	if (typeof window === 'undefined') {
		return 0;
	}

	return window.pageYOffset;
}

/* istanbul ignore next */
export function innerWidth() {
	if (typeof window === 'undefined') {
		return 0;
	}

	return window.innerWidth;
}

/* istanbul ignore next */
export function innerHeight() {
	if (typeof window === 'undefined') {
		return 0;
	}

	return window.innerHeight;
}

/* istanbul ignore next */
export function requestAnimationFrame() {
	const window = window || {};
	const polyfill = (callback) => {
		setTimeout(callback, 1000 / 60);
	};
	return window.requestAnimationFrame || polyfill;
}

/* instanbul ignore next */
export function globalRequire(...args) {
	if (!window) {
		return;
	}
	if (!window.require) {
		if (process.env.NODE_ENV !== 'production') {
			console.error('AMD require not defined. Are you running standalone mode?');
		}

		return;
	}

	return window.require.apply(window, args);
}

/* instanbul ignore next */
export function getHistory() {
	if (typeof window === 'undefined') {
		return 0;
	}

	return window.history;
}

/* instanbul ignore next */
export function getWindow() {
	return window;
}
